<div class="other-settings">
  <div class="loading-spinner" *ngIf="loading">
    <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
  </div>

  <div *ngIf="!loading">
    <!-- Max Attachments -->
    <section class="settings-section" [formGroup]="requestsConfigForm">
      <h3 class="section-heading">{{ 'request_v2.settings_dialog.other_settings.maxAttachmentsLabel' | translate }}</h3>
      <app-form-input
        class="maxWidth-350"
        label="{{ 'request_v2.settings_dialog.other_settings.maxAttachmentsLabel' | translate }}"
        formControlName="maxAttachments"
        data-cy="maxAttachments"
      >
        <app-form-error *ngIf="maxAttachments.touched && maxAttachments.hasError('required')">
          {{ 'request_v2.settings_dialog.other_settings.errors.required' | translate }}
        </app-form-error>
        <app-form-error *ngIf="maxAttachments.touched && (maxAttachments.hasError('pattern') || maxAttachments.hasError('max'))">
          {{ 'request_v2.settings_dialog.other_settings.errors.invalid' | translate }}
        </app-form-error>
      </app-form-input>
      <div class="row justify-start">
        <button
          class="bciti-button"
          [ngClass]="processingSubmit ? 'bciti-button--disabled' : 'bciti-button--secondary'"
          [disabled]="processingSubmit"
          (click)="cancel()"
        >
          <span>{{ 'request_v2.settings_dialog.other_settings.button.cancel' | translate }}</span>
        </button>
        <button
          class="bciti-button ml-10"
          [ngClass]="!validateForm() || processingSubmit ? 'bciti-button--disabled' : 'bciti-button--dark'"
          [disabled]="!validateForm() || processingSubmit"
          (click)="submit()"
        >
          <span class="submit-loader">
            {{ 'request_v2.settings_dialog.other_settings.button.submit' | translate }}
            <mat-spinner *ngIf="processingSubmit" diameter="20"></mat-spinner>
          </span>
        </button>
      </div>
    </section>

    <!-- Predefined Messages -->
    <section class="settings-section" *ngIf="langs">
      <div class="predefined-messages-header">
        <h3 class="section-heading">
          {{ 'request_v2.settings_dialog.other_settings.predefinedMessages.heading' | translate }}
          <div class="loading-spinner inline" *ngIf="savingMessages">
            <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
          </div>
        </h3>
        <button class="bciti-button bciti-button--dark add-btn" (click)="openAddMessageDialog()">
          + {{ 'request_v2.settings_dialog.other_settings.predefinedMessages.addButton' | translate }}
        </button>
      </div>

      <div class="lang-tabs" *ngIf="langs?.length > 1 && predefinedMessages.length > 0">
        <button
          *ngFor="let lang of langs"
          class="lang-tab"
          [class.active]="selectedLang === lang"
          (click)="switchLang(lang)"
        >
          {{ 'request_v2.settings_dialog.other_settings.predefinedMessages.langs.' + lang | translate }}
        </button>
      </div>

      <div class="messages-list" *ngIf="predefinedMessages.length > 0">
        <div class="message-card" *ngFor="let message of predefinedMessages">
          <div class="message-text">{{ getMessageText(message) }}</div>
          <div class="message-actions">
            <button
              class="bciti-button bciti-button--invisible action-btn"
              (click)="openEditMessageDialog(message)"
              [disabled]="savingMessages"
            >
              <i class="icon-edit"></i>
            </button>
            <button
              class="bciti-button bciti-button--invisible action-btn"
              (click)="openDeleteMessageDialog(message)"
              [disabled]="savingMessages"
            >
              <i class="icon-trash-bin"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="empty-state" *ngIf="predefinedMessages.length === 0">
        {{ 'request_v2.settings_dialog.other_settings.predefinedMessages.emptyState' | translate }}
      </div>
    </section>
  </div>
</div>
